import { Button, Col, DatePicker, Form, message, Row } from 'antd';
import React, { useCallback, useEffect, useState } from 'react'
import iconCalendar from "assets/images/datatable/calendar.svg"
import useGenericInfo from 'hooks/useGenericInfo';
import dayjs, { Dayjs } from 'dayjs';
import SelectPrefixForm from 'components/SelectPrefixForm/SelectPrefix';
import { getEmpresas } from 'services/Importadores/services';
import { filterOptions, parseToSelectOption } from 'util/funcionesNews';
import Storage from "util/store/Storage";
import { GetEstadosCupones } from '../service/cupones-autoservicio.service';

const { RangePicker } = DatePicker

interface IProps {
     handleFilter: () => Promise<any>;
     form: any;
}

const FiltroCupones = ({ handleFilter, form }: IProps) => {

     const FIELDS_NAMES = {
          FECHA_INICIO: ['fecha_inicio'],
          FECHA_FIN: ['fecha_fin'],
          ESTACIONES: ['estaciones'],
          ESTADO_ID: ['estado_cupo_id'],
     }

     const today = dayjs();
     // const [form] = Form.useForm();
     const { isAdmin } = useGenericInfo({ organizations: true })
     const { empresasHijos } = Storage.getState()
     const requiredRule = [{ required: true, message: "Campo requerido" }]
     const dateRangeRule = [
          {
               required: true,
               message: "Campo requerido",
               validator: (_: any, value: any) => {
                    if (!value || !value[0] || !value[1]) {
                         return Promise.reject(new Error("Campo requerido"))
                    }
                    return Promise.resolve()
               },
          },
     ]

     const [estacionOptions, setEstacionOptions] = useState<any>([])
     const [estadoOptions, setEstadoOptions] = useState<any>([])

     const handleInputChange = useCallback((fieldName: string, value: any): void => form.setFieldValue([fieldName], value), [form])

     const getEdS = useCallback(async () => {
          try {
               const empresas = await getEmpresas(empresasHijos)
               const dataParsed = parseToSelectOption(empresas, "alias", "value")
               const options = isAdmin ? dataParsed : [{ label: "TODOS", value: 0 }, ...dataParsed]

               setEstacionOptions(options)
               handleInputChange(FIELDS_NAMES.ESTACIONES[0], [options[0]?.value])
          } catch (error) {
               console.error("Error al obtener EDS:", error)
               message.error("No se han podido al obtener EDS")
          }
     }, [])

     const getEstadosCupones = async () => {
          try {
               const { data } = await GetEstadosCupones()
               const options = parseToSelectOption(data.body, "estado", "id")

               setEstadoOptions(options)
               handleInputChange(FIELDS_NAMES.ESTADO_ID[0], null)
          }
          catch (error) {
               console.error("Error al obtener estados de cupones:", error)
               message.error("No se han podido obtener los estados")
          }
     }

     const onSelectMultiSelect = (name: string, value: any) => {
          const current = form.getFieldValue(name) || [];

          if (value === 0) {
               handleInputChange(name, [0]);
               return;
          }

          const filtered = current.filter((item: number) => item !== 0);
          const updated = filtered.includes(value) ? filtered : [value, ...filtered];
          handleInputChange(name, updated);
     }

     useEffect(() => {
          getEdS()
          getEstadosCupones()
     }, [])



     return (
          <div className="filter-panel">
               <div className="filter-content">
                    <Form form={form} layout="horizontal">
                         <Row gutter={8} align="bottom" justify="start">
                              {/* Fecha */}
                              <Col xs={24} sm={12} md={7} lg={7}>
                                   <Form.Item name="fecha_range" rules={dateRangeRule} validateTrigger={["onChange", "onBlur"]}>
                                        <div className="range-picker-prefix">
                                             <img
                                                  src={iconCalendar || "/placeholder.svg"}
                                                  style={{ width: "18px", height: "18px" }}
                                                  alt="calendar"
                                             />
                                             <span className="prefix-text-date">Fecha*</span>
                                        </div>
                                        <div className="range-picker-container">
                                             <RangePicker
                                                  className="custom-range-picker"
                                                  format="YYYY-MM-DD"
                                                  style={{ width: "100%" }}
                                                  disabled={false}
                                                  disabledDate={(current: Dayjs) => {
                                                       const hoy = dayjs().endOf('day');
                                                       const limite = dayjs().subtract(3, 'month').endOf('day');
                                                       return current && (current.isAfter(hoy) || current.isBefore(limite));
                                                  }}
                                                  onCalendarChange={(values: any) => {
                                                       console.log("🔥🥵 ~ FilterPanel ~ values:", values)
                                                       if (values && values.length > 0 && values[0] && values[1]) {
                                                            handleInputChange("fecha_inicio", values[0])
                                                            handleInputChange("fecha_fin", values[1])
                                                            form.setFieldValue("fecha_range", values)
                                                       } else {
                                                            handleInputChange("fecha_inicio", "")
                                                            handleInputChange("fecha_fin", "")
                                                            form.setFieldValue("fecha_range", null)
                                                            form.setFields([
                                                                 {
                                                                      name: "fecha_range",
                                                                      errors: [],
                                                                 },
                                                            ])
                                                       }
                                                  }}
                                                  placeholder={[today.format("YYYY-MM-DD"), today.format("YYYY-MM-DD")]}
                                                  suffixIcon={null}
                                             />
                                        </div>
                                   </Form.Item>
                              </Col>


                              {/* Estación */}
                              <Col xs={24} sm={12} md={8} lg={8}>
                                   <SelectPrefixForm
                                        name="estaciones"
                                        mode='multiple'
                                        disabled={isAdmin}
                                        options={estacionOptions}
                                        defaultValue={[0]}
                                        prefixText="Estación*"
                                        rules={requiredRule}
                                        className="select-gray"
                                        maxTagCount='responsive'
                                        value={form.getFieldValue(FIELDS_NAMES.ESTACIONES)}
                                        filterOption={filterOptions}
                                        placeholder="Seleccione estación"
                                        onSelect={(value: number) => onSelectMultiSelect(FIELDS_NAMES.ESTACIONES[0], value)}
                                   />
                              </Col>

                              {/* Estado */}
                              <Col xs={24} sm={12} md={8} lg={6}>
                                   <SelectPrefixForm
                                        rules={requiredRule}
                                        name="estado_cupo_id"
                                        prefixText="Estado*"
                                        placeholder="Seleccione su estado"
                                        options={estadoOptions}
                                        disabled={false}
                                        className="select-gray"
                                        value={form.getFieldValue(FIELDS_NAMES.ESTADO_ID[0])}
                                   />
                              </Col>

                              {/* Botón Buscar */}
                              <Col xs={24} sm={12} md={3} lg={3} style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                                   <Button
                                        type="primary"
                                        icon={""}
                                        onClick={handleFilter}
                                        // loading={isConstulta} // ✅ Mostrar loading en el botón
                                        className="search-button"
                                        style={{
                                             marginBottom: "12px",
                                             width: "100%",
                                             height: "35px",
                                             borderRadius: "12px",
                                        }}
                                   >
                                        Buscar
                                   </Button>
                              </Col>
                         </Row>
                    </Form>
               </div>
          </div>
     )
}

export default FiltroCupones